// Wedding Theme Color Palette
// Based on your existing design preferences

export const weddingColors = {
  // Primary Colors (Earth Tones & Warm Neutrals)
  primary: {
    terracotta: '#a0522d',      // Warm terracotta
    russet: '#8b4513',          // Deep russet brown
    sandyBrown: '#f4a460',      // Sandy brown
    goldenrod: '#daa520',       // Rich goldenrod
    chocolate: '#d2691e',       // Chocolate brown
    peru: '#cd853f',            // Peru (warm tan)
  },

  // Accent Colors (Rich Jewel Tones)
  accent: {
    burgundy: '#800020',        // Deep burgundy
    darkBurgundy: '#722f37',    // Dark burgundy
    plum: '#673147',            // Smoky plum
    darkPlum: '#2e1a1e',        // Deep plum
    rosewood: '#bc8f8f',        // Soft rosewood
  },

  // Soft Neutrals
  neutral: {
    beige: '#f5f5dc',           // Classic beige
    oatmeal: '#ddd3c0',         // Warm oatmeal
    buttercream: '#fffacd',     // Soft buttercream
    khaki: '#f0e68c',           // Light khaki
    sage: '#8fbc8f',            // Sage green
    lightSage: '#90ee90',       // Light sage
  },

  // Special Accents
  special: {
    cobaltBlue: '#1e3a8a',      // Deep cobalt blue
    brightBlue: '#1e40af',      // Bright cobalt
    canaryYellow: '#ffd700',    // Canary yellow/gold
    brightGold: '#ffed4e',      // Bright gold
    softLavender: '#e6e6fa',    // Soft lavender
    orchid: '#dda0dd',          // Soft orchid/plum
  },

  // Badge Colors
  badges: {
    pioneer: {
      from: '#FF8C00',          // Dark orange
      to: '#FFD700',            // Gold
    },
    premier: {
      from: '#4B0082',          // Indigo
      to: '#8A2BE2',            // Blue violet
    },
    verified: {
      bg: '#4ade80',            // Green
      text: '#ffffff',
    }
  },

  // UI Colors
  ui: {
    background: '#fafaf9',      // Warm off-white
    cardBg: '#ffffff',
    borderLight: '#f5f5dc',     // Light beige border
    borderMedium: '#ddd3c0',    // Oatmeal border
    textPrimary: '#2e1a1e',     // Dark plum text
    textSecondary: '#722f37',   // Dark burgundy text
    textMuted: '#8b4513',       // Russet muted text
  }
};

// Gradient Combinations for Cards
export const weddingGradients = [
  `linear-gradient(135deg, ${weddingColors.primary.terracotta} 0%, ${weddingColors.primary.russet} 100%)`,
  `linear-gradient(135deg, ${weddingColors.accent.rosewood} 0%, ${weddingColors.primary.terracotta} 100%)`,
  `linear-gradient(135deg, ${weddingColors.primary.sandyBrown} 0%, ${weddingColors.primary.goldenrod} 100%)`,
  `linear-gradient(135deg, ${weddingColors.neutral.beige} 0%, ${weddingColors.neutral.oatmeal} 100%)`,
  `linear-gradient(135deg, ${weddingColors.accent.burgundy} 0%, ${weddingColors.accent.darkBurgundy} 100%)`,
  `linear-gradient(135deg, ${weddingColors.accent.plum} 0%, ${weddingColors.accent.darkPlum} 100%)`,
  `linear-gradient(135deg, ${weddingColors.primary.chocolate} 0%, ${weddingColors.primary.peru} 100%)`,
  `linear-gradient(135deg, ${weddingColors.neutral.sage} 0%, ${weddingColors.neutral.lightSage} 100%)`,
  `linear-gradient(135deg, ${weddingColors.special.orchid} 0%, ${weddingColors.special.softLavender} 100%)`,
];

// Tailwind-compatible class names
export const tailwindWeddingClasses = {
  // Backgrounds
  bgPrimary: 'bg-amber-700',        // Closest to terracotta
  bgSecondary: 'bg-amber-900',      // Closest to russet
  bgBurgundy: 'bg-red-900',         // Closest to burgundy
  bgSage: 'bg-green-200',           // Closest to sage

  // Text
  textPrimary: 'text-amber-900',
  textSecondary: 'text-red-900',
  textMuted: 'text-amber-700',

  // Borders
  borderPrimary: 'border-amber-200',
  borderSecondary: 'border-amber-300',

  // Buttons
  btnPrimary: 'bg-amber-700 hover:bg-amber-800 text-white',
  btnSecondary: 'bg-red-900 hover:bg-red-800 text-white',
  btnOutline: 'border-2 border-amber-700 text-amber-700 hover:bg-amber-50',
};

export default weddingColors;